
import Vue from "vue";
import { mapState } from "vuex";
import DatePickerDialog from "@/components/DatePickerDialog.vue";

export default Vue.extend({
  components: {
    DatePickerDialog,
  },
  computed: {
    ...mapState(["data"]),
    dateError(): string {
      if (!this.bufferConfig) {
        return "";
      }
      const promoStartDate = new Date(this.bufferConfig.promoStartDate);
      const promoEndDate = new Date(this.bufferConfig.promoEndDate);
      const promoDueDate = new Date(this.bufferConfig.promoDueDate);
      if (promoEndDate <= promoStartDate) {
        return "La date de fin d'opération doit être après la date de début";
      }
      if (promoDueDate <= promoStartDate) {
        return "La date max de remise des coupons doit être après la date de début";
      }
      return "";
    },
  },
  data: () => ({
    show: false,
    bufferConfig: null as null | Record<string, any>,
    edited: false,
    editedKey: "",
    watch: false,
    loading: false,
    loadingReset: false,
    showReset: false,
    password: "",
  }),
  async beforeMount() {
    if (!this.data.config.promoStartDate) {
      await this.$store.dispatch("refreshConfig");
    }
    this.bufferConfig = { ...this.data.config };
    this.watch = true;
  },
  methods: {
    updateValue(value: string) {
      if (this.bufferConfig) {
        this.bufferConfig[this.editedKey] = value;
      }
    },
    showPicker(key: string) {
      this.editedKey = key;
      this.show = true;
    },
    closeDialog() {
      this.editedKey = "";
      this.show = false;
    },
    async resetCampaign() {
      this.loadingReset = true;
      await this.$store.dispatch("resetCampaign", { password: this.password });
      await this.$store.dispatch("refreshConfig");
      this.password = "";
      this.loadingReset = false;
    },
    reset() {
      this.bufferConfig = { ...this.data.config };
    },
    async save() {
      this.loading = true;
      const result = await this.$store.dispatch(
        "updateConfig",
        this.bufferConfig
      );
      this.reset();
      this.loading = false;
      this.showReset = false;
    },
  },
  watch: {
    bufferConfig: {
      deep: true,
      handler() {
        let edited = false;
        if (this.watch) {
          for (const key in this.bufferConfig) {
            if (this.bufferConfig[key] !== this.data.config[key]) {
              edited = true;
            }
          }
        }
        this.edited = edited;
      },
    },
  },
});
